<template>
  <div :class="`drop-${isDropActive ? 'active' : 'inactive'}`">
    <div class="drop-zone text-center" @dragover.prevent="e=>e.dataTransfer.dropEffect = 'copy'" @dragenter="e=>e.dataTransfer.dropEffect = 'copy'" @dragleave="isDropActive = false" @drop.prevent="drop" @click="isDropActive = false">
      <h2 class="text-primary text-center">Drop files anywhere to<br />attach them to this referral</h2>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  created() {
    window.addEventListener('dragenter', this.enableDropzone)
  },
  data() {
    return {
      isDropActive: false,
    }
  },
  methods: {
    enableDropzone() {
      this.isDropActive = true
    },
    drop(e) {
      e.preventDefault()
      this.isDropActive = false
      this.$emit('drop', e)
    },
  },
  destroyed: function () {
    window.removeEventListener('dragenter', this.enableDropzone)
  },
}
</script>

<style scoped lang="scss">
.drop-active {
  border: 3px dashed var(--primary-color);
  background-color: var(--border-color);

  .drop-zone {
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999999;
    background-color: #f2f7f7e0; // #cbd9d9de; /* Black w/opacity */
    border: 8px dashed var(--primary-color);
    border-radius: 8px;
    overflow: hidden;
    justify-content: center;
    align-items: center;
  }
}
.drop-zone {
  display: none;
}
</style>